module.exports = __webpack_public_path__ + "static/media/physiotherapy-secondary.24fb9c33.jpg";